import * as React from 'react'
import { Button, Balloon, Icon } from '@alifd/next';

export default function SampleBtn(props: any) {
  const {i18n, sampleInfo = {}, onClose, isEmpty, btnLoading, tipShow} = props;
  const { enable, reason } = sampleInfo;

  const renderBtn = () => {
    // 无物流
    if (isEmpty) {
      return <div className="payment-button">
      <Button type="primary" size="medium" onClick={() => {
        onClose();
        document.getElementById('sidebar-chat-now').click();
      }}>
        {i18n['rightAction.chat']}
      </Button>
      <div style={{
        marginTop: '10px'
      }}>
        <Button type="primary" disabled>
          {i18n['btnGetSample']}
        </Button>
      </div>
    </div>
    }

    if ( enable ) {
      return <div className="payment-button">
        <Button type="primary" htmlType="submit" size="medium" loading={btnLoading}>
          {i18n['btnGetSample']}
        </Button>
      </div>
    } else {
      return <div className="payment-button">
        <Button type="primary" disabled>
          {i18n['btnGetSample']}
        </Button>
        <div style={{
          marginTop: "10px"
        }}>
          <Icon type="prompt" size="small" style={{
            color: '#FF6600',
            marginRight: '4px'
          }} />
          {reason}
        </div>
      </div>
    }
  }

  return <Balloon
  trigger={renderBtn()}
  align="t"
  className="tip-show"
  alignEdge
  closable={false}
  visible={tipShow}
  triggerType="hover"
  style={{
      width: 300
  }}
>
  {i18n['undue_tpl_helpers.strongWarningText1']} {i18n['undue_tpl_helpers.strongWarningText2']}
</Balloon>
}
